import {Component, OnInit} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-action',
  templateUrl: './modal-action.component.html',
  styleUrls: ['./modal-action.component.scss']
})
export class ModalActionComponent  {
  child_text: string='';
  // subject_text: string;
  title_text: string='';
  action: "dialog" | "deleteImg" = 'dialog';

  constructor(public dialogRef: MatDialogRef<ModalActionComponent>, public dialog: MatDialog) {
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    this.dialogRef.close(true);

  }


}
